export function checkDecimalInput(numberString: string | null | undefined) {
	if (!numberString || numberString.length === 0) return false;
	return /^[0-9]+\d*[,.]?\d{0,2}$/.test(numberString);
}


export function checkIntegerInput(numberString: string | null | undefined) {
	if (!numberString || numberString.length === 0) return false;
	return /^[0-9]\d*$/.test(numberString);
}


export function isInteger(value: number) {
	if (Number.isNaN(value)) return false;
	if (!isFinite(value)) return false;
	if (value > -2147483648 && value < 2147483647) return true;
	return false;
}

export function isDouble(value: number) {
	if (Number.isNaN(value)) return false;
	if (!isFinite(value)) return false;
	if (value >= -1.79769e+308 && value <= 1.79769e+308) return true;
	return false;
}



export function isInRange(value: number, range: number) {
	if (value >= (-1 * range) && value <= range) return true;
	return false;
}